import * as React from 'react';
import { DropDownContext, Options } from '.';
import { optionClasses, Option } from '@mui/base';

import clsx from 'clsx';
import { MUIStyledCommonProps, styled } from '@mui/system';
import { Checkbox } from '@/shared/components';

interface OptionStyledProps extends MUIStyledCommonProps {
  ownerState?: {
    value?: any;
  };
}

const StyledOption = styled(Option)<OptionStyledProps>(({ ownerState }) => ({
  display: 'flex',
  alignItems: 'center',
  [`&.${optionClasses.highlighted}`]:
    ownerState?.value !== 'apac_komodo_dropdown_clear'
      ? {
          color: '#fff',
          backgroundColor: '#1e8ae7!important',
        }
      : {},
}));

const CustomOption = (props: Options) => {
  const { disabled, value, children } = props;
  const { selectValue, multiple } = React.useContext(DropDownContext);
  const multipleSelectValue: any[] = Array.isArray(selectValue) ? selectValue : [];
  const optionChecked = multipleSelectValue?.indexOf(value) !== -1;

  return (
    <StyledOption
      slotProps={{
        root: {
          className: clsx('c-dropdown__option', disabled && 'c-dropdown__option--disabled', 'option-cursor'),
        },
      }}
      slots={{
        root: 'div',
      }}
      value={value || ''}
      disabled={disabled}
      ownerState={{
        value,
      }}
    >
      {multiple && value !== 'apac_komodo_dropdown_clear' && (
        <span className="c-checkbox dropdown-checkbox">
          <input type="checkbox" checked={multipleSelectValue?.indexOf(value) !== -1} readOnly />
          <span className="c-checkmark"></span>
        </span>
      )}
      {children}
    </StyledOption>
  );
};

export default CustomOption;
